import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { environment } from 'environments/environment'

export class ImsCommitHashInterceptor implements HttpInterceptor {
  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if ('headers' in event) {
          environment.actedImsCommitSha = event.headers.get('X-Acted-Ims-Commit-Sha') ?? environment.actedImsCommitSha
        }
      }),
    )
  }
}
